module.exports = __webpack_public_path__ + "static/media/blue.c36b8d81.jpg";